import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenAdidasPerformanceShirt = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[6].productName}
				color={product.allGear[6].color}
				size={product.allGear[6].sizes}
				price={product.allGear[6].price}
				img={product.allGear[6].img}
				miniImg1={product.allGear[6].miniImg1}
				miniImg2={product.allGear[6].miniImg2}
				miniImg3={product.allGear[6].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenAdidasPerformanceShirt;
